var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-config-section',{attrs:{"locked":!_vm.loggedin}},[_c('h2',[_vm._v("Rated")]),_c('p',[_vm._v("If you want to include games that you have rated but not logged a play for.")]),_c('div',{staticClass:"inputs"},[_c('core-filter-input-toggle',{attrs:{"text":"Include","on":"Yes","off":"No","filter":"config/lists/unplayed/rated"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }